// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General FAQ Section Styles */
.faq-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%; /* Full height to center vertically */
  padding: 20px;
}

.faq-title {
  font-size: 24px;
  font-weight: 700;
  color: #1B2559;
  margin-bottom: 20px;
}

.faq-items {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  justify-content: center; /* Center items in the row */
  max-width: 1000px;
  gap: 20px;
  margin: 20px 0;
}

.faq-item {
  width: 200px;
  height: 100px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-style: solid;
  border-color: #cfd2d6;
  border-width: 1px;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0px 2px 4px -2px #0000001A;
  transition: transform 0.2s;
  cursor: pointer;
  flex-direction: column;
  overflow-y: scroll;
  scrollbar-width: none;
  text-align: center;
  background-color: #eeeef5;
}

.faq-item:hover {
  transform: translateY(-3px);
}

.faq-item i {
  font-size: 24px;
  color: #007bff;
  margin-bottom: 10px;
}

.faq-item span {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.guest-faq-container {
  display: flex;
  flex-direction: column; /* Stack FAQ items vertically */
  margin-top: 10px;
  width: 100%;
  align-items: flex-end; /* Align items to the right */
  gap: 10px; /* Space between FAQ items */
}

.guest-faq-item {
  display: flex;
  align-items: center;
  padding: 4px; /* Adjusted padding */
  width: auto;
  max-width: 100%; /* Slightly smaller width */
  border: 1px solid #8859d9; /* Transparent border */
  background: white; /* White background */
  background-clip: padding-box; /* Ensures gradient only applies to the border */
  border-radius: 8px; /* Rounded corners */
  color: #8859d9; /* Text color */
  font-size: 13px; /* Smaller text size */
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.3s ease;
  position: relative;
}

.guest-faq-item::before {
  content: ''; /* Create a pseudo-element */
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(to right, #8859d9, #4c6bf5); /* Gradient border */
  border-radius: 8px; /* Match the border radius */
  z-index: -1; /* Place the pseudo-element behind the content */
}

.guest-faq-item:hover {
  color: white;
  transform: scale(1.05); /* Slightly scale up on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add shadow on hover */
}

.guest-faq-item i {
  margin-right: 8px; /* Space between icon and question */
  font-size: 18px; /* Adjusted icon size */
}

.guest-faq-item span {
  font-weight: 400; /* Normal font weight */
}


/* Dark Mode FAQ Section Styles */
.dark-mode .faq-section {
}

.dark-mode .faq-title {
  color: #e0e0e0;
}

.dark-mode .faq-item {
  background-color: #3b3b3b;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-color: #444;
}

.dark-mode .faq-item i {
  color: #1e90ff; /* Light blue for dark mode */
}

.dark-mode .faq-item span {
  color: #e0e0e0;
}

@media (max-width: 720px) {
  .faq-items {
    grid-template-columns: repeat(2, 1fr); /* On smaller screens, max 2 items per row */
  }
  .faq-item{
    width: 120px;
    height: 80px;
    border-width: 1px;
    border-radius: 6px;
    padding: 5px;
  }
  .faq-title {
    font-size: 16px;
  }
  .faq-item span {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FAQ.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,qCAAqC;EACnD,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,0CAA0C;EAC3D,uBAAuB,EAAE,4BAA4B;EACrD,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,gBAAgB;EAChB,WAAW;EACX,qBAAqB,EAAE,6BAA6B;EACpD,SAAS,EAAE,4BAA4B;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,qBAAqB;EACnC,WAAW;EACX,eAAe,EAAE,2BAA2B;EAC5C,yBAAyB,EAAE,uBAAuB;EAClD,iBAAiB,EAAE,qBAAqB;EACxC,4BAA4B,EAAE,gDAAgD;EAC9E,kBAAkB,EAAE,oBAAoB;EACxC,cAAc,EAAE,eAAe;EAC/B,eAAe,EAAE,sBAAsB;EACvC,eAAe;EACf,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uDAAuD,EAAE,oBAAoB;EAC7E,kBAAkB,EAAE,4BAA4B;EAChD,WAAW,EAAE,gDAAgD;AAC/D;;AAEA;EACE,YAAY;EACZ,sBAAsB,EAAE,+BAA+B;EACvD,wCAAwC,EAAE,wBAAwB;AACpE;;AAEA;EACE,iBAAiB,EAAE,oCAAoC;EACvD,eAAe,EAAE,uBAAuB;AAC1C;;AAEA;EACE,gBAAgB,EAAE,uBAAuB;AAC3C;;;AAGA,iCAAiC;AACjC;AACA;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC,EAAE,4CAA4C;EACrF;EACA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* General FAQ Section Styles */\n.faq-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  height: 100%; /* Full height to center vertically */\n  padding: 20px;\n}\n\n.faq-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1B2559;\n  margin-bottom: 20px;\n}\n\n.faq-items {\n  display: flex;\n  flex-wrap: wrap; /* Allows items to wrap to the next line */\n  justify-content: center; /* Center items in the row */\n  max-width: 1000px;\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.faq-item {\n  width: 200px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-style: solid;\n  border-color: #cfd2d6;\n  border-width: 1px;\n  border-radius: 6px;\n  padding: 10px;\n  box-shadow: 0px 2px 4px -2px #0000001A;\n  transition: transform 0.2s;\n  cursor: pointer;\n  flex-direction: column;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  text-align: center;\n  background-color: #eeeef5;\n}\n\n.faq-item:hover {\n  transform: translateY(-3px);\n}\n\n.faq-item i {\n  font-size: 24px;\n  color: #007bff;\n  margin-bottom: 10px;\n}\n\n.faq-item span {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n}\n\n.guest-faq-container {\n  display: flex;\n  flex-direction: column; /* Stack FAQ items vertically */\n  margin-top: 10px;\n  width: 100%;\n  align-items: flex-end; /* Align items to the right */\n  gap: 10px; /* Space between FAQ items */\n}\n\n.guest-faq-item {\n  display: flex;\n  align-items: center;\n  padding: 4px; /* Adjusted padding */\n  width: auto;\n  max-width: 100%; /* Slightly smaller width */\n  border: 1px solid #8859d9; /* Transparent border */\n  background: white; /* White background */\n  background-clip: padding-box; /* Ensures gradient only applies to the border */\n  border-radius: 8px; /* Rounded corners */\n  color: #8859d9; /* Text color */\n  font-size: 13px; /* Smaller text size */\n  cursor: pointer;\n  transition: transform 0.1s ease, box-shadow 0.3s ease;\n  position: relative;\n}\n\n.guest-faq-item::before {\n  content: ''; /* Create a pseudo-element */\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(to right, #8859d9, #4c6bf5); /* Gradient border */\n  border-radius: 8px; /* Match the border radius */\n  z-index: -1; /* Place the pseudo-element behind the content */\n}\n\n.guest-faq-item:hover {\n  color: white;\n  transform: scale(1.05); /* Slightly scale up on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add shadow on hover */\n}\n\n.guest-faq-item i {\n  margin-right: 8px; /* Space between icon and question */\n  font-size: 18px; /* Adjusted icon size */\n}\n\n.guest-faq-item span {\n  font-weight: 400; /* Normal font weight */\n}\n\n\n/* Dark Mode FAQ Section Styles */\n.dark-mode .faq-section {\n}\n\n.dark-mode .faq-title {\n  color: #e0e0e0;\n}\n\n.dark-mode .faq-item {\n  background-color: #3b3b3b;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n  border-color: #444;\n}\n\n.dark-mode .faq-item i {\n  color: #1e90ff; /* Light blue for dark mode */\n}\n\n.dark-mode .faq-item span {\n  color: #e0e0e0;\n}\n\n@media (max-width: 720px) {\n  .faq-items {\n    grid-template-columns: repeat(2, 1fr); /* On smaller screens, max 2 items per row */\n  }\n  .faq-item{\n    width: 120px;\n    height: 80px;\n    border-width: 1px;\n    border-radius: 6px;\n    padding: 5px;\n  }\n  .faq-title {\n    font-size: 16px;\n  }\n  .faq-item span {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
